import React from 'react';
import { useTranslation } from 'react-i18next';

export default function IpeLazyListSentinel({
  sentinelRef,
  loadingMore,
  hasMore,
  loadedCount,
  totalItems,
  className = '',
  itemUnit,
}) {
  const { t } = useTranslation('workbench');
  const unit = itemUnit || t('lazyList.unitImage');

  if (!hasMore) {
    if (totalItems > 0 && loadedCount >= totalItems) {
      return (
        <p className={`ipe-lazy-list__end${className ? ` ${className}` : ''}`} aria-live="polite">
          {t('lazyList.loadedAll', { count: totalItems, unit })}
        </p>
      );
    }
    return null;
  }

  return (
    <div
      ref={sentinelRef}
      className={`ipe-lazy-list__sentinel${className ? ` ${className}` : ''}`}
      aria-live="polite"
    >
      {loadingMore ? t('lazyList.loadingMore') : t('lazyList.scrollMore')}
    </div>
  );
}
